import { combineReducers } from 'redux';
import * as R from 'ramda';
import { SELECT_NETWORK } from '../../network/actions';
import { RECEIVE_SHIFTS, SELECT_SHIFT, DESELECT_SHIFT, SET_SHIFT_EXCHANGE_ID } from '../actions';

const items = (state = {}, action) => {
  switch (action.type) {
    case RECEIVE_SHIFTS:
      return R.indexBy(R.prop('id'), action.items);
    case SET_SHIFT_EXCHANGE_ID: {
      if (!action.shiftId) return state;

      return R.evolve({
        [action.shiftId]: R.assoc('exchange_id', parseInt(action.exchangeId, 10)),
      }, state);
    }
    case SELECT_NETWORK: return [];
    default: return state;
  }
};

const selected = (state = null, action) => {
  switch (action.type) {
    case SELECT_SHIFT:
      return action.shiftId;
    case DESELECT_SHIFT:
      return null;
    default: return state;
  }
};

export default combineReducers({ items, selected });
